import { isPlatformBrowser } from '@angular/common';
import {
  ApplicationRef,
  EventEmitter,
  Inject,
  Injectable,
  OnInit,
  Output,
  PLATFORM_ID
} from '@angular/core';
import { UserSessionService } from '@com-delta-idp/mnx-oauth';
import { CookieHelper } from '../../common/cookie-helper';
import { DataLayer } from '../../common/datalayer/datalayer';
import { ICorporatePartner } from '../../corporate-partner/corporate-partner.interface';
import { getCorporatePartner } from '../../corporate-partner/corporate-partner.method';
import { AccountSummaryService } from '../../services/accountsummary/account-summary.service';

@Injectable({
  providedIn: 'root'
})
export class SwitchingAccountService implements OnInit {
  public display: boolean;
  public accountType: any;
  public accountName: any;
  public displayCorporateName;
  public initialBusinessType: any;
  public businessAccount = false;
  public personalLoginDisplayText: any;
  public crprtAgrmntTypeCode = '';
  public crprtAgrmntId = '';
  public contractMgtEnt = '';
  public program = '';
  tripLinkAccount = false;
  oaSmeAccount = false;
  partnerId = 'default';
  corpPartner: ICorporatePartner;
  businessAccountOptionsLists: any = this.initializeViewData();
  public businessUser: boolean;
  public hideBusinessDetails: boolean;
  public intranetLink = false;
  @Output() change: EventEmitter<boolean> = new EventEmitter();
  @Output() corporatePartnerChange: EventEmitter<ICorporatePartner> =
    new EventEmitter();

  @Output() displayBody: EventEmitter<boolean> = new EventEmitter();

  constructor(
    private ref: ApplicationRef,
    private accountSummaryDetails: AccountSummaryService,
    private cookieHelper: CookieHelper,
    @Inject(PLATFORM_ID) private platformId: Object,
    private datalayer: DataLayer,
    private userSession: UserSessionService
  ) {}

  ngOnInit(): void {
    this.display = false;
  }

  getAccountCookie(cookieName) {
    if (isPlatformBrowser(this.platformId)) {
      const name = cookieName + '=';
      const temp = document.cookie.split(';');
      for (let i = 0; i < temp.length; i++) {
        let ca = temp[i];
        while (ca.charAt(0) === ' ') {
          ca = ca.substring(1);
        }
        if (ca.indexOf(name) === 0) {
          return ca.substring(name.length, ca.length);
        }
      }
      return '';
    }
  }

  setInitialBusinessType(businessTypeValue, corporateName) {
    this.initialBusinessType = businessTypeValue;
    this.accountType = this.businessAccount
      ? this.initialBusinessType.businesstravelerDisplayText
      : this.initialBusinessType.personalLoginDisplayText;
    if (this.userSession.getServiceWorkerCheck()) {
      this.setInitialBusinessTypeHelper(corporateName);
    }
  }

  setInitialBusinessTypeHelper(corporateName) {
    this.accountSummaryDetails.getAccountSummaryDetails().subscribe((res) => {
      if (res && res.crprtAgrmntTypeCode) {
        this.accountSummaryDetails.getAccountType('edpCorpData').subscribe(
          (resData) => {
            if (resData) {
              if (resData && resData.value !== 'P') {
                const index = resData.value.split(':')[1];
                if (res != null && res !== undefined) {
                  const names = res.crprtName ? res.crprtName.split('|') : '';
                  const types = res.crprtAgrmntTypeCode
                    ? res.crprtAgrmntTypeCode.split('|')
                    : null;
                  const contractMgtEnt = res.contractMgtEnt
                    ? res.contractMgtEnt.split('|')
                    : null;
                  const program = res.program ? res.program.split('|') : null;
                  const id = res.crprtAgrmntId
                    ? res.crprtAgrmntId.split('|')
                    : null;
                  if (types && contractMgtEnt && program) {
                    this.setAdditionalBusinessUserInfo(
                      types[index],
                      contractMgtEnt[index],
                      program[index],
                      id[index]
                    );
                  }
                  corporateName = names[index];
                }
              }
              this.accountName = corporateName ? corporateName : '';
              this.displayCorporateName = corporateName ? corporateName : '';
              // added to update selected account name when cookie is set
              let cookieObj = this.getAccountCookie('account');
              if (cookieObj && cookieObj.length) {
                cookieObj = JSON.parse(cookieObj);
                this.accountName = decodeURIComponent(cookieObj['name']);
              }
            }
          },
          (error) => {
            const cookieObject = Object.assign(
              {},
              { hasCookie: this.cookieHelper.getCookies('corp') }
            );
            if (cookieObject.hasCookie) {
              const corpName = this.cookieHelper
                .getCookies('corp')
                .split('|')[1]
                .split('=')[1]
                .replace(/#/g, ' ');
              this.businessUser = true;
              this.intranetLink = true;
              this.accountName = corpName;
              this.toggleAccount(true, false);
              this.setCorporateName(corpName);
            } else {
              this.accountSummaryDetails.postAccountType('P').subscribe(
                (resp) => {
                  this.businessAccount = false;
                  this.cookieHelper.setCookieName(
                    'restrictToPersonal',
                    'personal',
                    0,
                    true
                  );
                  this.toggleAccount(this.businessAccount, false);
                },
                (error) => {
                  console.log(error);
                  this.businessAccount = false;
                  this.cookieHelper.setCookieName(
                    'restrictToPersonal',
                    'personal',
                    0,
                    true
                  );
                  this.toggleAccount(this.businessAccount, false);
                }
              );
            }
          }
        );
      }
    });
  }

  setCorporateName(corpName) {
    this.displayCorporateName = corpName;
  }

  setIntranetlink(val) {
    this.intranetLink = val;
  }

  setSelectedAccount(
    selectedAccountType,
    accountName,
    isBusiness,
    isOaSmeAcct,
    corpPartnerId,
    businessAccount,
    accountIndexVal
  ) {
    this.accountType = selectedAccountType;
    this.accountName = accountName;
    this.businessAccount = isBusiness;
    this.oaSmeAccount = isOaSmeAcct;
    this.businessAccountOptionsLists.isOaSmeAccount = isOaSmeAcct;
    // added to set Cookie when account changes
    let stringifiedObject: any = {
      isBusiness: this.businessAccount,
      name: encodeURIComponent(this.accountName.toString()),
      businessAccountOptionsList: {
        isOaSmeAccount: this.oaSmeAccount,
        partnerId: corpPartnerId,
        accountIndex: accountIndexVal
      }
    };
    stringifiedObject = JSON.stringify(stringifiedObject);
    if (this.businessAccount) {
      this.intranetLink = businessAccount.isIntranetLink;
      this.setAdditionalBusinessUserInfo(
        businessAccount.crprtAgrmntTypeCode,
        businessAccount.contractMgtEnt,
        businessAccount.program,
        businessAccount.corporateAgreementId
      );
    } else {
      this.setAdditionalBusinessUserInfo(null, null, null, null);
    }
    // this.cookieHelper.setCookieName('account', '', 0);
    this.cookieHelper.setCookieName('account', stringifiedObject, 0, true);
  }

  getInitialBusinessType() {
    return this.initialBusinessType;
  }

  showSwitching() {
    this.display = true;
    this.displayBody.emit(this.display);
  }

  hideSwitching() {
    this.display = false;
    this.displayBody.emit(this.display);
    setTimeout(() => {
      const switchAccount = document.getElementById('switch-account-overlay');
      if (switchAccount) {
        switchAccount.click();
      } // added to fix display update issue
    }, 100);
  }

  getDisplayStatus() {
    return this.display;
  }

  toggleAccount(selectedBusinessAccountFlag, showCorporateForNonLoggedIn) {
    const hasCorpCookie = this.cookieHelper.getCookies('corp');
    if (selectedBusinessAccountFlag) {
      if (hasCorpCookie) {
        this.businessAccount = true;
        this.partnerId = 'edp';
      } else {
        if (this.userSession.getServiceWorkerCheck()) {
          this.toggleAccountHelper();
        }
      }
    } else {
      this.businessAccount = showCorporateForNonLoggedIn ? true : false;
    }
    this.getOtherAccountDetailsFromCookie(hasCorpCookie);
    this.displayCorporateName = '';
    this.corpPartner = getCorporatePartner(this.partnerId);
    this.corporatePartnerChange.emit(this.corpPartner);
  }

  toggleAccountHelper() {
    this.accountSummaryDetails.getAccountSummaryDetails().subscribe((res) => {
      if (res && res.crprtAgrmntTypeCode) {
        this.businessAccount = true;
      } else {
        this.businessAccount = false;
      }
    });
  }

  getOtherAccountDetailsFromCookie(corpCookie) {
    const account = this.getAccountCookie('account');
    const setPartnerToPersonal =
      this.cookieHelper.getCookieValue('restrictToPersonal');
    let tempPartnerId = '';
    const hipmunkCookie =
      this.cookieHelper.getCookieValue('isHipmunk') !== null
        ? this.cookieHelper.getCookieValue('isHipmunk')
        : false;
    if (account && account.length) {
      const parseAccount = JSON.parse(account);
      const otherBusinessAccountOptionsList =
        parseAccount['businessAccountOptionsList'];
      this.oaSmeAccount = otherBusinessAccountOptionsList['isOaSmeAccount'];
      tempPartnerId = otherBusinessAccountOptionsList['partnerId'];
    } else if (setPartnerToPersonal && setPartnerToPersonal.length) {
      tempPartnerId = setPartnerToPersonal;
    } else if (corpCookie) {
      tempPartnerId = 'edp';
    }
    this.partnerId = hipmunkCookie ? 'hipmunk' : tempPartnerId;
  }

  setBusinessUser(flag) {
    this.businessUser = flag;
  }

  displayBusinessAccounts(flag) {
    this.hideBusinessDetails = !flag;
  }

  // DDCFB  need to validate pageName & channelId values
  getUserInfo() {
    const info = {
      isBusinessAccount: this.businessAccount ? true : false,
      businessAccountOptionsLists: this.businessAccountOptionsLists,
      isOaSmeAccount: this.oaSmeAccount ? true : false,
      isBusinessUser: this.businessUser ? true : false,
      isIntranetLink: this.intranetLink ? true : false,
      selectedCompany: this.displayCorporateName
        ? this.displayCorporateName
        : this.accountName,
      pageName: 'home',
      channelId: 'ecomm'
    };
    return info;
  }

  setAdditionalBusinessUserInfo(
    corpAgreementCode: any,
    contractMgntEntity: any,
    programName: any,
    id: any
  ) {
    this.crprtAgrmntTypeCode = corpAgreementCode;
    this.contractMgtEnt = contractMgntEntity;
    this.program = programName;
    this.crprtAgrmntId = id;
  }

  getAdditionalBusinessUserInfo() {
    const additionalInfo = {
      crprtAgrmntTypeCode: this.crprtAgrmntTypeCode
        ? this.crprtAgrmntTypeCode
        : null,
      crprtAgrmntId: this.crprtAgrmntId ? this.crprtAgrmntId : null,
      contractMgtEnt: this.contractMgtEnt ? this.contractMgtEnt : null,
      program: this.program ? this.program : null
    };
    return additionalInfo;
  }

  initializeViewData() {
    return { isOaSmeAccount: false };
  }
}
